import { LeafletProvider, createLeafletContext } from '@react-leaflet/core';
import React, { forwardRef, useCallback, useEffect, useImperativeHandle, useState } from 'react';
import { useResizeContext } from '../../common/components/ResizeablePanel';
import './windyContainer.css';

function WindyContainerComponent({ bounds , boundsOptions , center , children , className , placeholder , style , whenReady , zoom , maxZoom, minZoom, apiKey, ...options }, forwardedRef) {
    const [context, setContext] = useState(null);
    const {width, height} = useResizeContext();
    useImperativeHandle(forwardedRef, ()=>context?.map ?? null, [
        context
    ]);
    const mapRef = useCallback((node)=>{
        if (node !== null && context === null) {
            const opts = { ...options, key: apiKey, verbose: false }
            window.windyInit(opts, windyAPI => {
                const map = windyAPI.map;
                if (center != null && zoom != null) {
                    map.setView(center, zoom);
                } else if (bounds != null) {
                    map.fitBounds(bounds, boundsOptions);
                }
                if (maxZoom != null) {
                    map.setMaxZoom(maxZoom);
                }
                if (minZoom != null) {
                    map.setMinZoom(minZoom);
                }
                if (whenReady != null) {
                    map.whenReady(whenReady);
                    map.invalidateSize()
                }
                setContext(createLeafletContext(map));
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(()=>{
        return () => {
            //context?.map.remove();
        }
    }, [context]);
    useEffect(() => {
        context?.map?.invalidateSize();
    }, [context?.map,width, height])
    const contents = context ? React.createElement(LeafletProvider, {
        value: context
    }, children) : placeholder ?? null;
    return mapRef.current ? mapRef.current : React.createElement("div", { className, id: 'windy', style, ref: mapRef }, contents);
}
export const WindyContainer = forwardRef(WindyContainerComponent);